const React = require("react");

function SortDescendingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
  }));
}

module.exports = SortDescendingIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/SortDescendingIcon.js
 ** module id = 614
 ** module chunks = 0
 **/